// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { object } from 'prop-types'

const SuggestionsWrapper = ({ children, containerProps }) => (
  <div
    {...containerProps}
    className={`${containerProps.className} site-auto-suggest-wrapper`}>
    <div className={'site-auto-suggest-nested-wrapper'}>{children}</div>
  </div>
)

SuggestionsWrapper.propTypes = {
  children: object,
  containerProps: object.isRequired,
}

export default SuggestionsWrapper
